import React, { Component } from 'react';
import "./toolbar.css";
import Search from "./search"
import Select, { Creatable, Async } from 'react-select';
import classNames from 'classnames';

import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize';
import moment from 'moment';
import { api } from 'api';
import 'react-dates/lib/css/_datepicker.css';


let TIPO = [
    {id: 14, value: [1, 4], label:"TRANSACCIÓN (ELECTRONICA/DEPOSITO)"},
    // {id: 1, value: 1, label:"ELECTRONICA"}, // Transacción
    // {id: 4, value: 4, label:"DEPOSITO"},    // Transacción

    {id: 5, value: 5, label:"TARJETA"},
    {id: 2, value: 2, label:"CHEQUE"},
    {id: 6, value: 6, label:"EFECTIVO"},

]

const getVendedores = (search, props) => {
    let params = {search}
    params.is_active = true

    if (props.permisos && !props.permisos.ver_todo_liquidacion_historial) params.vendedorId = props.idVendedor

    return api.get("liquidaciones/get_usuarios_vendedores_liquidaciones", params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};

const getUsuarioAsignaciones = (search, props) => {
    let params = {search}
    params.is_active = true

    return api.get("liquidaciones/get_usuarios_liquidaciones", params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};

export default class ToolbarHistorialLiquidaciones extends Component {
    state = {
        asyncValue: this.props.asyncValue ? this.props.asyncValue : null,
        vendedor: null,
        usuario_aprobacion: null,
        focusedStart: false,
        dateStart: null,
        focusedEnd: false,
        dateEnd: null,
        vendedoresOptions: null,
        usuariosAsignacionesOptions: null,
    }

    componentWillMount() {
        const resul = getVendedores('', this.props)
        resul.then((valor) => {
            this.setState({ vendedoresOptions: valor })
        })

        const resUsuariosAsignaciones = getUsuarioAsignaciones('', this.props)
        resUsuariosAsignaciones.then((valor) => {
            this.setState({ usuariosAsignacionesOptions: valor })
        })
    }

    render() {
        return (
            <div className="row col-12 p-0">
                <div className="row col-12 m-0 text-lg-left">
                    <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Fecha Inicial</span>
                        <SingleDatePicker
                            // className="form-control"
                            placeholder={"Fecha Inicio"}
                            // date={this.state.dateStart}
                            date={this.props.fecha_I}
                            focused={this.state.focusedStart}
                            isOutsideRange={() => false}
                            onDateChange={(value) => {
                                this.props.changeRangeDate(value, true, null);
                            }}
                            onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
                            numberOfMonths={1}
                            showClearDate={true}
                            id={"dateStart"}
                        />
                    </div>
                    <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Fecha Final</span>
                        <SingleDatePicker
                            // className="form-control"
                            placeholder={"Fecha Final"}
                            // date={this.state.dateEnd}
                            date={this.props.fecha_F}
                            focused={this.state.focusedEnd}
                            isOutsideRange={() => false}
                            onDateChange={(value) => {
                                this.props.changeRangeDate(value, null, true);
                            }}
                            onFocusChange={({ focused }) => this.setState({ focusedEnd: focused })}
                            numberOfMonths={1}
                            showClearDate={true}
                            id={"dateEnd"}
                        />
                    </div>
                    <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Tipo</span>
                        <Select
                            isClearable={true}
                            className={classNames('react-select-container')}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            options={TIPO}
                            placeholder={"Tipo"}
                            value={this.props.valorMovimiento}
                            onChange={this.props.changeTipoLiquidacion}
                        />
                    </div>
                    {(this.props.buscar !== undefined) && (
                        <div className="col-lg-3 col-md-3 mt-2 text-right search d-flex align-items-end">
                            <Search buscar={this.props.buscar} buscador={this.props.buscador} placeholder={this.props.placeholder} />
                        </div>
                    )}
                </div>
                <div className="row col-12 m-0 text-lg-left">
                    <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Aprobado por</span>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            loadOptions={(search) => getUsuarioAsignaciones(search, this.props)}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (`${option["first_name"]} ${option["last_name"]}`)}
                            type="text"
                            onChange={(e) => {
                                e ? this.props.changeUsuarioAprobaciones(e.id) : this.props.changeUsuarioAprobaciones(null)
                            }}
                            // cacheOptions
                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            defaultOptions={this.state.usuariosAsignacionesOptions}
                            placeholder="Seleccionar.."
                        />
                    </div>
                    <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Vendedor</span>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            loadOptions={(search) => getVendedores(search, this.props)}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (`${option["first_name"]} ${option["last_name"]}`)}
                            type="text"
                            onChange={(e) => {
                                e ? this.props.changeVendedor(e.id) : this.props.changeVendedor(null)
                            }}
                            // cacheOptions
                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            defaultOptions={this.state.vendedoresOptions}
                            placeholder="Seleccionar.."
                        />
                    </div>
                </div>
            </div>
        )
    }
}
